import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FileLoaderPipe } from '../../pipes/file-loader.pipe';
import { PdfComponent } from '../pdf/pdf.component';
import { Component, Inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FileMapEntry } from 'common';

@Component({
    selector: 'lib-full-screen-dialog',
    standalone: true,
    imports: [MatDialogModule, MatProgressSpinnerModule, MatButtonModule, MatIconModule, PdfComponent, FileLoaderPipe, AsyncPipe],
    template: `
        <mat-dialog-content class="h-100 w-100">

            @if (file | libLoadFile | async; as url) {

                @switch (file.type) {
                @case ("application/pdf") { <lib-pdf [srcUrl]="url || file.localUrl || file.serverUrl"></lib-pdf> }
                @default { 
                    <!-- Close button for img only. -->
                    <button mat-icon-button mat-dialog-close class="close-button">
                <mat-icon>close</mat-icon>
                </button>

                <img [src]="file.safeLocalUrl || file.serverUrl"
                     alt="ID Document"
                     [style.transform]="'rotate(' + rotation + 'deg)'">
                }}

            } @else {
                <mat-spinner style="max-width: 6rem;"></mat-spinner>
            }

        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Close</button>
        </mat-dialog-actions>
    `,
    styles: [`
        lib-pdf {
            height: 100%;
            width: 100%;
        }

        img {
            object-fit: contain;
            max-width: 100%;
            max-height: calc(100% - 0.5rem);
            transition: transform 0.3s ease-in-out;
        }

        .close-button {
            position: absolute;
            top: 0.25rem;
            right: 0.25rem;
        }

        // Full screen dialog.
        mat-dialog-content {
            max-height: unset !important;
            flex: 1 0 0;
            padding: 0 !important;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    `]
})
export class FullScreenImageDialogComponent {

    public file: FileMapEntry;
    public rotation: number = 0;

    constructor(
        public dialogRef: MatDialogRef<FullScreenImageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { file: any; initialRotation?: number }
    ) {

        this.file = data.file;
        this.rotation = data.initialRotation ?? 0;
    }

}
